import { render } from "./PrivacyPolicy.vue?vue&type=template&id=245c4440&scoped=true"
const script = {}

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=245c4440&lang=css"
import "./PrivacyPolicy.vue?vue&type=style&index=1&id=245c4440&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245c4440"]])

export default __exports__